import { useCallback, useState } from 'react';
import apiClient from '@app/network/apiClient';
import Lang from '@lang/en';
import { CustomErrorCallInterface, getErrorMessage } from './getErrorMessage';
import showNotification from '@root/src/app/designSystem/toastNotification/selectToast';

interface SaveFormInterface<DataType> {
  loading: boolean;
  error: string;
  save: (
    url: string,
    postData: DataType,
    method?: 'put' | 'post'
  ) => Promise<void>;
  isSaved: boolean;
  setError: (value: string) => void;
}
const useSaveForm = <DataType>(): SaveFormInterface<DataType> => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [isSaved, setIsSaved] = useState(false);

  const save = useCallback(
    async (url: string, postData: DataType, method?: 'put' | 'post') => {
      setLoading(true);
      setError('');
      setIsSaved(false);
      try {
        const response =
          method === 'put'
            ? await apiClient.put(url, postData)
            : await apiClient.post(url, postData);

        if (response.status >= 400) {
          const error = new Error(Lang.invalidResponse);
          (error as CustomErrorCallInterface).response = response.data;
          throw error;
        }

        showNotification({
          text: Lang.healthCheckSaveOrderSuccessfully,
          type: 'success',
        });

        setIsSaved(true);
      } catch (error) {
        const errorMessage = getErrorMessage(error as CustomErrorCallInterface);
        setError(errorMessage);
        showNotification({
          text: Lang.healthCheckCouldNotSaveError,
          type: 'error',
        });
      }

      setLoading(false);
    },
    []
  );

  return { loading, error, save, isSaved, setError };
};

export default useSaveForm;
